module.exports = __webpack_public_path__ + "static/1072-f0298048581dcf36a727d3bcf799112a.png";